// Os valores de "impressora" abaixo devem ser idênticos aos salvos pelo
// sistema de gestão (cabine-foto-gestao) em totem.config.impressora.
export const printerTypes = {
  CITIZEN_CZ_01_4X6: "citizen-cz-01-4x6",
  DNP_RX_1_6X4: "dnp-rx-1-6x4",
};

export const printerFormats = {
  FORMATO_6X4: "6x4",
  FORMATO_4X6: "4x6",
};

// Formato enviado ao backend quando o totem não tem impressora configurada.
export const printerFormatDefault = printerFormats.FORMATO_6X4;

const printerFormatByType = {
  [printerTypes.CITIZEN_CZ_01_4X6]: printerFormats.FORMATO_4X6,
  [printerTypes.DNP_RX_1_6X4]: printerFormats.FORMATO_6X4,
};

// Recebe o valor salvo em totem.config.impressora e retorna o formato de
// impressão correspondente. Cai no padrão (6x4) quando não houver configuração.
export const getFormatoImpressao = (impressora) => {
  return printerFormatByType[impressora] || printerFormatDefault;
};

const toInt = (valor, fallback = 0) => {
  const n = parseInt(valor, 10);
  return Number.isNaN(n) ? fallback : n;
};

// Offset de calibração de posição (em mm) legado, configurado no gestão por
// totem físico (sem distinção de tipo de foto). Salvo em
// totem.config.impressoraOffsetX / impressoraOffsetY (dois campos separados).
// Convenção (coordenadas de tela): X negativo=esquerda/positivo=direita;
// Y negativo=cima/positivo=baixo. Padrão 0 quando não configurado.
// Mantido como fallback para configurações antigas.
export const getOffsetImpressao = (config) => {
  return {
    x: toInt(config?.impressoraOffsetX),
    y: toInt(config?.impressoraOffsetY),
  };
};

// Calibração de posição (offset X/Y em mm) específica por impressora E por
// tipo de foto. Salva no gestão em totem.config.impressoraCalibracao com a
// estrutura: { [impressora]: { [tipoFoto]: { x, y } } }.
//
// Ex.: impressora "citizen-cz-01-4x6" + tipoFoto "polaroid" retorna a
// calibração específica dessa combinação. Faz fallback, nessa ordem, para:
//   1) a calibração específica da combinação impressora + tipoFoto;
//   2) o offset plano legado (impressoraOffsetX/Y);
//   3) { x: 0, y: 0 }.
export const getCalibracaoImpressao = (config, impressora, tipoFoto) => {
  const legado = getOffsetImpressao(config);
  const tipo = String(tipoFoto || "").toLowerCase();
  const especifico = config?.impressoraCalibracao?.[impressora]?.[tipo];
  if (especifico) {
    return {
      x: toInt(especifico.x, legado.x),
      y: toInt(especifico.y, legado.y),
    };
  }
  return legado;
};
